import React, { VoidFunctionComponent, useState } from 'react';
import { Button } from "@/components/responsive/commun/button";


interface Props {
  isPositionFixed: boolean;
  isQuantityHidden: boolean;
  optionNumbers: number[];
  handleClick: (quantity: number) => void;
  isBasketButtonEnable?: boolean;
  type?: "primary" | "secondary" | "tertiary" | 'adaptive' | 'black',
  bascketButtonClassName?: string
}

export const BasketButton: VoidFunctionComponent<Props> = ({
  isPositionFixed,
  isQuantityHidden,
  optionNumbers,
  handleClick,
  isBasketButtonEnable = true,
  type,
  bascketButtonClassName = "",
}) => {
  const [quantity, setQuantity] = useState(1);

  return <div
    className={`basket-button ${isPositionFixed && 'fixed'} ${isQuantityHidden && 'no-padding'}`}
  >
    {!isQuantityHidden && !isPositionFixed &&(
        <label className='quantity' htmlFor='quantity'>
          <p>Quantité</p>
        </label>
    )}
    <div className='dropdown'>
      {!isQuantityHidden && <select disabled={!isBasketButtonEnable}
        style={{
          background: `url(/assets/images/responsive/icons/btn-chevron-down.svg) right 12px center / 14px no-repeat`,
        }}
        className={`${!isBasketButtonEnable && 'basket-disabled'}`}
        onChange={(evnet) => {
        setQuantity(evnet.target?.value ? Number(evnet.target.value) : 1);
        }}
      >
        {optionNumbers.map((i) => (
          <option key={`option ${i}`} value={i}>
            {i}
          </option>
        ))}
      </select>}
      <Button
        className={`${bascketButtonClassName}`}
        type={type || "adaptive"}
        callBack={() => handleClick(quantity)}
      >
        <img src={"/assets/images/responsive/icons/basket.svg"} alt='icone de panier' width='24' height='24' />
        <p>{isBasketButtonEnable ? "Ajouter au panier" : "Vérifier la disponibilité"}</p>
      </Button>
    </div>
  </div>
}